var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.templateData.templateId
    ? _c("div", { staticClass: "row design-section" }, [
        _c(
          "div",
          { staticClass: "col-lg-10 order-lg-1 order-2 d-flex flex-column" },
          [
            _c("div", { staticClass: "text-xl-center row no-gutters" }, [
              _c("div", { staticClass: "col-xl-6 col-9 offset-xl-5" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col-4" }, [
                    _c(
                      "div",
                      { attrs: { id: "marketing-templates-container" } },
                      [
                        _c("template-card", {
                          attrs: {
                            edit: _vm.editTemplate,
                            delete: _vm.deleteTemplate,
                            actions: _vm.templateActions,
                            "template-id": _vm.templateData.templateId,
                            thumbnail: _vm.templateData.templateThumbnail,
                            "template-name": _vm.templateData.templateName,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _vm.save
                        ? _c("i18n", {
                            staticClass: "ml-auto text-regular-gray m-0",
                            attrs: {
                              path: "global.actions.selectItem",
                              tag: "h5",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function () {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "clickable text-primary",
                                          attrs: { id: "select-template" },
                                          on: { click: _vm.goSelectTemplate },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("global.words.other")
                                            ) + "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4258011696
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ])
    : _c("div", { staticClass: "row justify-content-center mt-3" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("h5", { staticClass: "text-light-gray my-3" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$tc("global.words.click", 1)) + "\n      "
            ),
            _c(
              "a",
              {
                staticClass: "clickable text-primary",
                attrs: { id: "select-template" },
                on: { click: _vm.goSelectTemplate },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.words.here")) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("campaigns.messages.toBeginDesigningEmail")) +
                "\n    "
            ),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }